export default "__VITE_PUBLIC_ASSET__5872193b__"